import { ReactNode, useMemo, useState } from 'react';
import { User } from 'commons/types/user';
import { UserContext } from './context';

const UserProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<User>({
    agency: { id: 1, name: '', isActive: false, cnpj: '' },
    authenticated: false,
    contents: [],
    profile: { id: 0, code: '', name: '', isRestricted: false },
    resources: [],
    user: { id: 0, fullName: '', email: '' },
  });

  const contextValue = useMemo(() => ({ user, setUser }), [user]);

  return <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>;
};

export default UserProvider;
